import { Popover } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledPopoverButton = styled.button`
    user-select: none;
    text-align: left;
    height: 32px;
    white-space: nowrap;
    cursor: pointer;
    border-color: transparent;
    background-color: transparent;
    width: 100%;
    border-radius: 6px;
    padding-inline: 12px;

    &:hover {
        color: var(--brand-7);
        background-color: var(--gray-2);
    }

    &:disabled {
        color: var(--gray-6);
        cursor: not-allowed;
    }
`;

export const StyledPopover = styled(Popover)``;

export const PopoverGlobalStyles = createGlobalStyle`
    .ant-popover-placement-bottom,
    .ant-popover-placement-bottomLeft,
    .ant-popover-placement-bottomRight {
        padding-top: 0 !important;
    }

    .ant-popover-inner-content {
        padding-block: 4px;
        padding-inline: 0;
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: min-content;
        border-radius: 6px;
        overflow: hidden;
        min-width: 130px;
}
`;
